import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AppSidebar } from "@/components/app-sidebar";
import { AuthGate } from "@/components/auth-gate";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { NotificationsProvider } from "@/components/notifications-provider";

export const Route = createFileRoute("/_dashboard")({
  component: DashboardLayout,
});

function DashboardLayout() {
  return (
    <AuthGate>
      <SidebarProvider>
        <NotificationsProvider>
          <AppSidebar />
          <SidebarInset>
            <Outlet />
          </SidebarInset>
        </NotificationsProvider>
      </SidebarProvider>
    </AuthGate>
  );
}
